import { fetchJson } from "@/services/api-client";
import { Organization, OrganizationMemberInvite } from "@/types/organization";
import { User } from "@/types/user";

export async function requestOrganizationJoin({
  organizationId,
}: {
  organizationId: string;
}) {
  return fetchJson<{ success: boolean }>(
    "/api/join-request",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ organizationId }),
    },
    { fallbackErrorMessage: "Failed to submit join request" },
  );
}

export async function sendOrganizationInvites(
  organization: Organization,
  user: User,
  invites: OrganizationMemberInvite[],
): Promise<OrganizationMemberInvite[]> {
  const { results } = await fetchJson<{ results: OrganizationMemberInvite[] }>(
    "/api/invite",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ organization, user, invites }),
    },
    { fallbackErrorMessage: "Failed to send organization user invites" },
  );

  return results;
}
